// extracted by mini-css-extract-plugin
export default {"root":"IconArrowHead_root__yhjgu","rootTinyArrow":"IconArrowHead_rootTinyArrow__mnVn8"};